import {REACTIONS} from '@wix/live-video-commons'

export const getReactionCode = (emoji: string) => REACTIONS.find(item => item.id === emoji).code
